/**
 * list的容器
 * 负责连接list和数据服务和list组件
 */
import Jobs from '../cmps/jobs';
import {Connect} from 'services';
import createService from 'services/create-service';
import {withRouter} from 'react-router-dom'

var Service = createService('http://rms.chinahr.com/api/job/list?token=2658424c-a08a-422f-90f3-e29db154d719&page=1&pageSize=1000&companyId=:companyId');

var CateService = createService('http://rms.chinahr.com/api/company/list?token=2658424c-a08a-422f-90f3-e29db154d719');
console.log('------------------------------------------------------')
console.log(Service)
console.log('------------------------------------------------------')
var initProps = {
  JobList: [],
  total: 0,
  CateList: []
}

//通过Connect监听ComList和JobList服务，如果有数据更新，重新渲染list组件
var ListPage = Connect([Service, CateService], function (JobListData, CateData) {
  var data = JobListData.data;
  var cateData = CateData.data;


  if (cateData && cateData.retMsg && cateData.retMsg.length > 0) {
    initProps.CateList = cateData.retMsg;
  }
  if (data && data.retMsg && data.retMsg.length > 0) {
    initProps.JobList = data.retMsg;
    initProps.total = data.totalCount
  }
  // console.log(initProps)
  return initProps;
}, function (JobListIns, CateIns) {
  var params = this.props.match.params;
  return {
    loadData: function (companyId) {
      JobListIns.loadData({
        companyId: companyId
      });
      CateIns.loadData();
    }
  }
})(Jobs);

/**
 * need中存储了服务器渲染需要的action信息
 * match中存储了路由信息，从路由中获取参数，确定需要发送的action
 * action存储在数据服务的actions属性中
 */
ListPage.need = [
  function (match) {
    return Service.loadData();
  }
];

export default ListPage;



// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/containers/listPage.js